// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: white;
}

ion-title {
  font-size: 30px;
  font-weight: 600;
  margin: 24px 0;
  color: black;
  font-family: AppFont;
  padding: 0 24px;
}

.more-list {
  background: transparent;
  padding: 0 24px;
}
.more-list ion-item {
  --background: #1b1b1b;
  --padding-start: 14px;
  --padding-end: 0px;
  --min-height: 55px;
  margin-bottom: 20px;
  border-radius: 1px;
}
.more-list ion-icon {
  height: 20px;
  margin-right: 12px;
}
.more-list ion-label {
  color: #fff;
  font-family: AppFont;
  font-size: 16px;
  font-weight: bold;
}
.more-list .arrow {
  height: 16px;
  width: 16px;
  margin: 0 0 0 16px;
}

.eintracht {
  --background: var(--ion-color-black);
  color: white;
  font-size: 30px;
  text-transform: uppercase;
}

.cross {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 22px;
  height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAGA;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AAAD;;AAGA;EACC,uBAAA;EACA,eAAA;AAAD;AAEC;EACC,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,kBAAA;AADF;AAIC;EACC,YAAA;EACA,kBAAA;AAFF;AAKC;EACC,WAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;AAHF;AAMC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAQA;EACC,oCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AALD;;AAQA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AALD","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\t--background: white;\n}\nion-title {\n\tfont-size: 30px;\n\tfont-weight: 600;\n\tmargin: 24px 0;\n\tcolor: black;\n\tfont-family: AppFont;\n\tpadding: 0 24px;\n}\n\n.more-list {\n\tbackground: transparent;\n\tpadding: 0 24px;\n\n\tion-item {\n\t\t--background: #1b1b1b;\n\t\t--padding-start: 14px;\n\t\t--padding-end: 0px;\n\t\t--min-height: 55px;\n\n\t\tmargin-bottom: 20px;\n\t\tborder-radius: 1px;\n\t}\n\n\tion-icon {\n\t\theight: 20px;\n\t\tmargin-right: 12px;\n\t}\n\n\tion-label {\n\t\tcolor: #fff;\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t\tfont-weight: bold;\n\t}\n\n\t.arrow {\n\t\theight: 16px;\n\t\twidth: 16px;\n\t\tmargin: 0 0 0 16px;\n\t}\n\n}\n.eintracht {\n\t--background: var(--ion-color-black);\n\tcolor: white;\n\tfont-size: 30px;\n\ttext-transform: uppercase;\n}\n\n.cross {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\twidth: 22px;\n\theight: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
